module.exports = __webpack_public_path__ + "static/media/Enmascarar grupo 301.4071a4d5.svg";